module.exports = __webpack_public_path__ + "fonts/icomoon.149c7bba.woff";